import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ShoppingCartDto } from 'src/app/core/dtos/dto';
import { selectShoppingCart, selectShoppingCartItemCount } from 'src/app/state/shopping-cart.selectors';

@Component({
  selector: 'app-shopping-cart-summary',
  templateUrl: './shopping-cart-summary.component.html',
  styleUrls: ['./shopping-cart-summary.component.scss']
})
export class ShoppingCartSummaryComponent implements OnInit {

  shoppingCart$: Observable<ShoppingCartDto>;
  shoppingCartItemCount$: Observable<number>;
  @Input() isRegFlow: boolean;

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
    this.shoppingCart$ = this.store.pipe(select(selectShoppingCart));
    this.shoppingCartItemCount$ = this.store.pipe(select(selectShoppingCartItemCount));
  }

}
